// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  raceId: __t.u64().primaryKey().name("race_id"),
  season: __t.u32(),
  state: __t.string(),
  startsAt: __t.timestamp().name("starts_at"),
  gridAt: __t.timestamp().name("grid_at"),
  laps: __t.u8(),
  players: __t.u8(),
  field: __t.u8(),
  winnerName: __t.string().name("winner_name"),
  finishedAt: __t.timestamp().name("finished_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
